import notifyTypingOperation from 'owa-service/lib/operation/notifyTypingOperation';
import ucmaServiceOptions from './ucmaServiceOptions';

export default function notifyTyping(chatSessionId: number, isTyping: boolean): Promise<boolean> {
    return notifyTypingOperation(
        {
            chatSessionId,
            typingCancelled: !isTyping,
        },
        ucmaServiceOptions
    );
}
